export const CLEAR_TEMP_NEW_VID = "CLEAR_TEMP_NEW_VID";
export const CLEAR_SELECTED_VEHICLE = "CLEAR_SELECTED_VEHICLE";

export const TEMP_UPDATE_VEHICLE_ADDRESS = "TEMP_UPDATE_VEHICLE_ADDRESS";